import NotificationCard from "../ui/notifications/NotificationCard";
import EmptyState from "../ui/pages/EmptyState";

function NotificationsTable(props) {
  const { notifications = [], onNotificationUpdate, ntype } = props;

  const notificationsFiltered = notifications
    .filter((notification) => {
      // If no query parameter filter (or "All" segment), show everything
      if (!ntype) {
        return true;
      }

      const selectedSegment = ntype.toUpperCase();
      const notificationCategory = (
        notification.category ||
        notification.model_type ||
        ""
      ).toLowerCase();

      // Filings segment (?ntype=f or ?ntype=F)
      if (selectedSegment === "F") {
        return notificationCategory === "filing";
      }

      // Finances segment (?ntype=fi or ?ntype=FI)
      if (selectedSegment === "FI") {
        return (
          notificationCategory === "finance" ||
          notificationCategory === "budget" ||
          notificationCategory === "financial_insights"
        );
      }

      return true;
    })
    .sort((a, b) => {
      // Sort by timestamp (newest first)
      const timestampA = a.date?.timestamp || 0;
      const timestampB = b.date?.timestamp || 0;

      if (timestampA && timestampB) {
        return timestampB - timestampA;
      } else if (timestampA) {
        return -1;
      } else if (timestampB) {
        return 1;
      } else {
        const dateA = a.date
          ? new Date(a.date.year, a.date.month - 1, a.date.day)
          : new Date(0);
        const dateB = b.date
          ? new Date(b.date.year, b.date.month - 1, b.date.day)
          : new Date(0);
        return dateB - dateA;
      }
    });

  if (notificationsFiltered.length > 0) {
    return (
      <div className="notice">
        {notificationsFiltered.map((notification) => (
          <NotificationCard
            key={notification.id}
            id={notification.id}
            message={notification.message}
            date={notification.date}
            entity={notification.title || notification.type}
            url={notification.link}
            seen={notification.seen}
            model_type={notification.model_type}
            onNotificationUpdate={onNotificationUpdate}
          />
        ))}
      </div>
    );
  }

  return <EmptyState />;
}

export default NotificationsTable;
